import { api } from './api';

export class WorkflowError extends Error {
  constructor(message: string, public readonly details?: any) {
    super(message);
    this.name = "WorkflowError";
  }
}

export async function resumeGraphWorkflow(
  taskId: string | null,
  inputData: Record<string, any>,
  workflowId?: string | null,
  workflowName?: string
): Promise<any> {
  try {
    console.log("Resuming workflow", {
      taskId,
      workflowId,
      workflowName,
      inputDataKeys: inputData ? Object.keys(inputData) : {},
    });

    // Get current state_version from workflow status if workflowId is provided
    let stateVersion: number | undefined;
    if (workflowId) {
      try {
        const statusResponse: any = await api.get(`/api/crud/workflow/status/${workflowId}`);
        const statusData = statusResponse?.data || statusResponse;
        stateVersion = statusData?.result?.workflow?.current_task?.state_version || 
                      statusData?.state_version || 
                      1;
        console.log("Retrieved state_version:", stateVersion);
      } catch (statusError) {
        console.warn("Failed to retrieve state_version, using default:", statusError);
        stateVersion = 1; // Default to 1 if status fetch fails
      }
    }

    const requestBody: any = {
      data: inputData || {},
    };
    
    // Include state_version if retrieved
    if (stateVersion != null) {
      requestBody.state_version = stateVersion;
    }
    
    // Include workflow_name for authorization if available
    // This prevents 403 errors by allowing PDP to check against workflow name instead of task ID
    if (workflowName) {
      requestBody.workflow_name = workflowName;
    }

    // Call backend API endpoint which will handle Orchestration Service URL
    const response: any = await api.post(`/api/crud/workflow/resume/${taskId}`, requestBody);

    return response?.data || response;
  } catch (error) {
    console.error("Workflow resume failed:", error);
    throw new WorkflowError(
      error instanceof Error ? error.message : "Failed to resume workflow",
      { originalError: error }
    );
  }
}

export async function executeGraphWorkflow(
  workflowName: string,
  inputData: Record<string, any>
): Promise<any> {
  try {
    if (!workflowName?.trim()) {
      throw new WorkflowError("Workflow name is required");
    }

    console.log("Executing workflow", {
      workflowName,
      inputDataKeys: inputData ? Object.keys(inputData) : {},
    });

    // Call backend API endpoint which will handle Orchestration Service URL
    const response: any = await api.post("/api/crud/workflow/start", {
      workflow_name: workflowName,
      data: inputData || {},
    });

    return response?.data || response;
  } catch (error) {
    console.error("Workflow execution failed:", error);
    throw new WorkflowError(
      error instanceof Error ? error.message : "Failed to execute workflow",
      { originalError: error }
    );
  }
}
